import { render } from "./Doctor.vue?vue&type=template&id=55572f22"
import script from "./Doctor.vue?vue&type=script&lang=js"
export * from "./Doctor.vue?vue&type=script&lang=js"

import "./Doctor.vue?vue&type=style&index=0&id=55572f22&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__